import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { includes as _includes, isObject as _isObject } from 'lodash';

import { pluginTypes } from 'helpers/whiteLabel';
import { getThumbFileFromEntity } from 'helpers/items';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import CreacheckConditions from 'components/layout/whiteLabel/CreacheckConditions';

import FormInput from 'components/forms/FormInput';
import FormLangInput from 'components/forms/FormLangInput';
import FormLangRichEditor from 'components/forms/FormLangRichEditor';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormImageWithPreview from 'components/forms/FormImageWithPreview';

import List from 'components/List';

class WhiteLabelPluginData extends EntityPropsUpdater {
  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      entity,
      formStatusMainLogo,
      doNotify,
    } = this.props;
    const fileUploadedMessage = messages.file_uploaded;

    if (prevProps.formStatusMainLogo.pending && !formStatusMainLogo.pending && !formStatusMainLogo.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('mainLogo', [], formStatusMainLogo.response);
      this.updateEntity('mainLogo', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }
  };

  isWhiteLabelLanguageChecked = language => {
    return !!_includes(this.props.entity.getLanguages(), language);
  };

  whiteLabelLanguageChange = e => {
    const { target } = e;
    const language = target.value;
    const { checked } = target;

    const { entity, changeEntity } = this.props;
    let newValue;
    if (checked) {
      newValue = entity.getLanguages().slice();
      newValue.push(language);
    } else {
      newValue = entity.getLanguages().filter(r => {
        return r !== language;
      });
    }

    changeEntity({ ...entity.updateValue('languages', newValue) });
  };

  fileUpload = (name, images) => {
    if (_isObject(images) && images.length === 1) {
      const fd = new FormData();
      fd.append('file', images[0]);
      fd.append('logoType', name);

      switch (name) {
        case 'mainLogo':
          this.props.uploadMainLogo(this.props.entity.getId(), fd);
          break;
      }
    }
  };

  fileReset = name => {
    this.updateEntity(name, null);
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
      languages,
    } = this.props;

    let mainLogoUrl;
    if (entityLoaded) {
      if (entity.getMainLogo().getId()) {
        const thumbnail = getThumbFileFromEntity(entity.getMainLogo());
        if (thumbnail) {
          mainLogoUrl = thumbnail.getWebLink();
        }
      }
    }

    return (
      <div className="clearfix">
        {entityLoaded && (
          <div>
            <List noRender listName="languages" url="/api/languages.json" list={languages} />

            <Row>
              <Col xs={12} md={inModal ? 12 : 4}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <p className="form-group-title">{messages.formGroup.basic_information}</p>
                    <div className="form-group-attached">
                      <FormInput
                        label="ID"
                        name="id"
                        value={entity.getId()}
                        meta={entity.getIdMetaInformation()}
                        validation={entity.getIdValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled || !inModal}
                      />
                      <FormInput
                        label={messages.name}
                        name="name"
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormAutocomplete
                        label={messages.type}
                        name="type"
                        value={entity.getType()}
                        meta={entity.getTypeMetaInformation()}
                        validation={entity.getTypeValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                        clearable
                        options={pluginTypes(messages)}
                      />
                      <div className="form-group form-group-default padding-10">
                        <FormSwitchery
                          label={messages.featured}
                          name="isFeatured"
                          checked={entity.getIsFeatured()}
                          value
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </div>
                      <FormInput
                        label={messages.dependent_on}
                        name="dependentOn"
                        value={entity.getDependentOn()}
                        meta={entity.getDependentOnMetaInformation()}
                        validation={entity.getDependentOnValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>

                    <p className="m-t-15">
                      {messages.languages}
                      {languages.pending && <i className="m-l-10 fa fa-circle-notch fa-spin" />}
                    </p>

                    <div>
                      {languages.data.list.map((language, i) => {
                        return (
                          <div className="checkbox check-success" key={i}>
                            <input
                              disabled={disabled}
                              id={'whiteLabelLanguage' + i}
                              name="languages[]"
                              type="checkbox"
                              value={language.id}
                              checked={this.isWhiteLabelLanguageChecked(language.id)}
                              onChange={this.whiteLabelLanguageChange}
                            />
                            <label for={'whiteLabelLanguage' + i}>{language.name}</label>
                          </div>
                        );
                      })}
                    </div>

                    <div>
                      <FormImageWithPreview
                        label="Main logo"
                        name="mainLogo"
                        url={mainLogoUrl}
                        onChange={this.fileUpload}
                        onReset={this.fileReset}
                        pending={this.props.formStatusMainLogo.pending}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={inModal ? 12 : 4}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <p className="form-group-title">{messages.description}</p>
                    <div className="form-group-attached">
                      <FormLangRichEditor
                        label={messages.description}
                        name="description"
                        value={entity.getDescription()}
                        meta={entity.getDescriptionMetaInformation()}
                        validation={entity.getDescriptionValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormLangRichEditor
                        label={messages.settings_instructions}
                        name="settingsHelp"
                        value={entity.getSettingsInstructions()}
                        meta={entity.getSettingsInstructionsMetaInformation()}
                        validation={entity.getSettingsInstructionsValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>

                    <p className="m-t-15 form-group-title">{messages.legal}</p>
                    <div className="form-group-attached">
                      <div className="form-group form-group-default padding-10">
                        <FormSwitchery
                          name="termsOfUseAcceptationNeeded"
                          checked={entity.getTermsOfUseAcceptationNeeded()}
                          value
                          label={messages.terms_of_use}
                          onChange={this.updateEntity}
                        />
                      </div>
                      <div className="form-group form-group-default padding-10">
                        <FormSwitchery
                          name="contractAcceptationNeeded"
                          checked={entity.getContractAcceptationNeeded()}
                          value
                          label={messages.contract}
                          onChange={this.updateEntity}
                        />
                      </div>
                      <div className="form-group form-group-default padding-10">
                        <FormSwitchery
                          name="orderDataProcessingAcceptationNeeded"
                          checked={entity.getOrderDataProcessingAcceptationNeeded()}
                          value
                          label={messages.order_data_processing}
                          onChange={this.updateEntity}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={inModal ? 12 : 4}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <p className="form-group-title">{messages.prices}</p>
                    <div className="form-group-attached">
                      <FormLangInput
                        langKey="description"
                        label={messages.price_from}
                        name="priceShortInfo"
                        value={entity.getPriceShortInfo()}
                        meta={entity.getPriceShortInfoMetaInformation()}
                        validation={entity.getPriceShortInfoValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        type="number"
                        label={messages.sortingPrice}
                        name="sortingPrice"
                        value={entity.getSortingPrice()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <CreacheckConditions
              inModal={inModal}
              entity={entity}
              updateEntity={this.updateEntity}
              disabled={disabled}
            />
          </div>
        )}
      </div>
    );
  }
}
WhiteLabelPluginData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    languages: state.list.languages,
    user: state.login.user,
    formStatusMainLogo: state.formStatus.whiteLabelPluginMainLogo,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    uploadMainLogo: (whiteLabelPluginId, args) => {
      formStatusDispatchHelper(
        'whiteLabelPluginMainLogo',
        '/api/whitelabelplugins/' + whiteLabelPluginId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WhiteLabelPluginData)
);
